<template>
  <div>
    <ul class="event-type-colors">
      <li v-for="(val, index) in colors" :key="index">
        <input
          type="radio"
          :id="'clr-' + index"
          name="event-type-clr"
          v-model="form[color_prop]"
          :value="val"
        />
        <label :for="'clr-' + index" :class="'clr-' + val"></label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    form: {},
    color_prop: {}
  },
  data() {
    return {
      colors: [
        "chill",
        "sunflower",
        "nephritis",
        "carrot",
        "belize",
        "alizarin",
        "wisteria",
        "prunus",
        "midnightblue",
        "concrete"
      ]
    };
  }
};
</script>
<style scoped>
.event-type-colors li label.clr-chill {
  background-color: #1e90ff;
}
.event-type-colors li label.clr-sunflower {
  background-color: #f1c40f;
}
.event-type-colors li label.clr-nephritis {
  background-color: #27ae60;
}
.event-type-colors li label.clr-carrot {
  background-color: #e67e22;
}
.event-type-colors li label.clr-belize {
  background-color: #2980b9;
}
.event-type-colors li label.clr-alizarin {
  background-color: #e74c3c;
}
.event-type-colors li label.clr-wisteria {
  background-color: #8e44ad;
}
.event-type-colors li label.clr-prunus {
  background-color: #e84393;
}
.event-type-colors li label.clr-midnightblue {
  background-color: #5f27cd;
}
.event-type-colors li label.clr-concrete {
  background-color: #95a5a6;
}
</style>
